/**
 * Auth state management
 */

import { signal } from '@preact/signals';
import { api, setUnauthorizedHandler } from '../api/client';
import { disconnect } from '../ws/client';
import { clearNotices } from '../push/notices';

export const isAuthenticated = signal(api.hasToken());
export const showAuthPrompt = signal(false);

// Wire up the 401 handler. Tear down the WS too: the socket captured the now
// rejected token at connect() time and would otherwise keep retrying with the
// stale credential. The re-login path (login() -> isAuthenticated effect in
// main.tsx) reconnects with the fresh token (pwa-console-v2-8).
setUnauthorizedHandler(() => {
  isAuthenticated.value = false;
  showAuthPrompt.value = true;
  disconnect();
});

export function login(token: string) {
  api.setToken(token);
  isAuthenticated.value = true;
  showAuthPrompt.value = false;
}

export function logout() {
  localStorage.removeItem('jarvis_token');
  // The words of past notifications do not outlive the sign-in.
  void clearNotices();
  isAuthenticated.value = false;
  showAuthPrompt.value = true;
}

export function checkAuth(): boolean {
  if (!api.hasToken()) {
    showAuthPrompt.value = true;
    return false;
  }
  return true;
}
